import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 1,
	height: 20,
	viewBox: "0 0 1 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		width: 1,
		height: 20,
		fill: "#575A85"
	})
});
export { SvgLine as ReactComponent };
